import { useContext } from 'react';
import useRakenneosaNavV2 from './services/useRakenneosaNavV2';
import RakenneosaNavView from './views/RakenneosaNavView';
import { ReportTemplateContext } from '../../ReportTemplate/ReportTemplateContext';
import { findLinkedProjectId } from '../../../../utils/ptsUtils';
import useTestiTypeV2 from './services/useTestiTypeV2';
import VetolujuusView from './views/VetolujuusView';
import ApiFeedbackBanner from './views/ApiFeedbackBanner';

export const TYYPPI = 'Veto'; // matches OPTIONS.testi_tyypit / PORANÄYTE_TESTI_OPTIONS, not the block's own "Vetolujuus" label
export const DEFAULT_ARVO = { diameter: 55, vetolujuus: '', murtosyvyysFrom: '', murtosyvyysTo: '', murtosyvyysType: 'up', murtotapa: 'Osittain runkoainesta leikaten', lisahuomiot: '' };

// Calls useRakenneosaNavV2 directly (rather than through the shared
// RakenneosaPickerV2 wrapper) so this block's own data-fetching
// (useTestiTypeV2 below) keys off the SAME optimistic nav the tarkastuskohde
// tab UI uses — see PoranayteBlockV2 for why.
export default function VetolujuusBlockV2({ data, onChange, card, tableStartNumber }) {
  const id_kiinteisto = card?.id_kiinteisto ?? null;
  const templateCtx = useContext(ReportTemplateContext);
  const linkedProjectId = findLinkedProjectId(templateCtx?.sections ?? []);
  const activeSectionName = templateCtx?.activeSection?.name ?? null;
  const navSvc = useRakenneosaNavV2(id_kiinteisto, data?.nav || {}, next => onChange({ ...data, nav: next }), linkedProjectId, activeSectionName);
  const nav = navSvc.nav;
  const svc = useTestiTypeV2(nav.tkId, TYYPPI, DEFAULT_ARVO);

  return (
    <div>
      <RakenneosaNavView id_kiinteisto={id_kiinteisto} svc={navSvc} showRakenneosaTabs={false} />
      <ApiFeedbackBanner feedback={svc.feedback} onClose={svc.clearFeedback} />
      {nav.tkId && <VetolujuusView {...svc} taulukkoNum={tableStartNumber ?? 1} />}
    </div>
  );
}
